var GroupEditorComponent = new JS.Class(EditorComponent, {
  initialize: function(
    titleSelector,
    groupAreaSelector,
    groupDescriptionSelector,
    groupMembers,
    cohortPath
  ) {
    this.titleField = $(titleSelector);
    this.groupArea = $(groupAreaSelector);
    this.description = $(groupDescriptionSelector);
    this.cohortPath = cohortPath;
    this.users = {};
    var that = this;
    $.each(JSON.parse(groupMembers) || [], function(i, user) {
      that.users[user.id] = user;
    });

    this.$userList = this.groupArea.find('#memberList');
    var $search = this.groupArea
      .find('input[name="search"]')
      .select2({
        placeholder: 'Search for a user...',
        minimumInputLength: 3,
        ajax: {
          url: '/json/search/lookup/suggestUser/',
          dataType: 'json',
          quietMillis: 250,
          data: function(term, page) {
            return {
              query: term,
              start: (page - 1) * 6,
              types: 'user',
              cohortPaths: JSON.stringify([that.cohortPath]),
            };
          },
          results: function(data, page) {
            data = data.result;
            return {
              results: $.map(data.results, function(user) {
                if (that.users.hasOwnProperty(user.id)) {
                  user = null;
                }
                return user;
              }),
              more: page * 6 < data.total,
            };
          },
        },
        formatResult: function(result) {
          return (
            '<div class="userProfileItem"><img src="' +
            result.icon +
            '" width="24" height="24" align="left"> \
				<div class="name">' +
            result.title +
            ' <span class="profile">' +
            result.id +
            '</span></div> \
				<div style="clear: both;"></div></div>'
          );
        },
        formatSelection: function(result) {
          return result.title;
        },
      })
      .change(function(e) {
        var user = e.added;
        if (user) {
          user.access = 'member'; // give them user access by default
          that.users[user.id] = user;
          that.updateUserList();
        }
      });

    this.$userList.on('change', 'input[type="radio"]', function(e) {
      var $this = $(this);
      var userID = $this.attr('name');
      var access = $this.val();
      that.users[userID].access = access;
    });

    this.$userList.on('click', '.remove-user', function(e) {
      var userID = $(this).data('id');
      delete that.users[userID];
      $search.select2('data', null);
      that.updateUserList();
    });

    $.ajaxSetup({ cache: true });
    $.getScript(baseMedia + 'lib/dust/compiled_templates/misc.dust').done(
      function() {
        that.updateUserList();
      }
    );
  },

  updateUserList: function() {
    var $userList = this.$userList;
    var templateData = {
      accessLevels: [
        {
          name: 'Member',
          value: 'member',
        },
        {
          name: 'Group Admin',
          value: 'admin',
        },
      ],
      users: $.map(this.users, function(user) {
        return user;
      }),
    };
    dust.render('userList', templateData, function(err, html) {
      var $contents = $userList.contents();
      if ($contents.length) {
        $contents.replaceWith(html);
      } else {
        $userList.append(html);
      }
    });
  },

  getSaveData: function() {
    return {
      Group: {
        joinPermission: $('input[name=joinPermission]:checked').val(),
        title: this.titleField.val(),
        memberJson: JSON.stringify(
          $.map(this.users, function(user) {
            return user;
          })
        ),
        description: this.description.val(),
      },
    };
  },
});
